import React, { Component, PropTypes } from 'react';

import clock from '../utils/clock';
import moment from '../utils/moment-twitter';

export default class LiveMoment extends Component {
  static propTypes = {
    children: PropTypes.func,
    date: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.instanceOf(Date),
    ]),
    format: PropTypes.string,
    liveUpdate: PropTypes.bool.isRequired,
    titleFormat: PropTypes.string,
  };

  static defaultProps = {
    date: null,
    format: 'MMMM Do YYYY, h:mm a',
    liveUpdate: true,
    titleFormat: 'MMMM Do YYYY, h:mm a',
  };

  componentDidMount() {
    if (this.props.liveUpdate) {
      this.subscription = clock.addListener(
        'seconds.30', () => this.forceUpdate()
      );
    }
  }

  componentWillUnmount() {
    if (this.subscription) { this.subscription.remove(); }
  }

  render() {
    const {
      date,
      children,
      format,
      titleFormat,
      // So that rest doesn't contain this prop and cause a JSX error.
      liveUpdate, // eslint-disable-line no-unused-vars
      ...rest
    } = this.props;

    const dateMoment = moment(date);

    return (
      <time {...rest} title={dateMoment.format(titleFormat)}>
        {children ?
          children(dateMoment)
          :
          moment(dateMoment).format(format)
        }
      </time>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/LiveMoment.jsx
 **/